// extracted by mini-css-extract-plugin
export default {"tabs":"T--z","tablist":"U--z","tablistItem":"V--z"};